export default __webpack_public_path__ + "img/eLNUcRXO.618e6732.svg";